<template>
  <div :class="[$style.wrap, $style.config]">
    <div :class="$style.inner">
      <header :class="$style.header">
        <BaseHeading size="h2" as="h3">
          {{ data?.fields?.header }}
        </BaseHeading>
        <BaseHeading size="h6">
          {{ data?.fields?.subheader }}
        </BaseHeading>
        <MarkedParser
          :md="data?.fields?.copy"
          :class="['u-fs-p1', $style.copy]"
        />
      </header>

      <div
        v-if="data?.fields?.references?.filter?.(instanceOfCard)?.length"
        :class="$style.cardGrid"
      >
        <div
          v-for="card in data?.fields?.references?.filter?.(instanceOfCard)"
          :key="card?.sys?.id"
          :class="$style.card"
        >
          <BasePicture
            :img-class="$style.icon"
            :src="`${card?.fields?.media?.fields?.file?.url}?w=121&h=121&fit=thumb`"
            alt=""
          />

          <MarkedParser
            :md="card?.fields?.copy"
            :class="['u-fs-p1', $style.cardCopy]"
          />
        </div>
      </div>

      <div v-if="data?.fields?.ctas?.length" :class="$style.ctaContainer">
        <CallToAction
          v-for="cta in data.fields.ctas"
          :key="cta?.sys?.id"
          :class="$style.cta"
          :cta="cta"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeContentBlockWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  data: TypeContentBlockWithoutUnresolvableLinksResponse
}>()
</script>

<style lang="scss" module>
.config {
  --inner-max-width: 1316px;

  --padding-spacing: 20px;

  --cardGrid-template-columns: 1fr;

  @include media('xs') {
    --cardGrid-template-columns: repeat(2, 1fr);
  }

  @include media('md') {
    --cardGrid-template-columns: repeat(4, minmax(auto, 315px));
  }
}

.wrap {
  background-color: var(--gray-1);
}

.header {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  max-width: 700px;
  margin: 0 auto 25px;
  text-align: center;
}

.inner {
  max-width: calc(var(--inner-max-width) + (var(--padding-spacing) * 2));
  padding: 54px var(--padding-spacing) 40px;
  margin: auto;
}

.cardGrid {
  display: grid;
  justify-content: center;
  grid-template-columns: var(--cardGrid-template-columns);
  gap: 21px;
}

.card {
  padding: 34px 39px 41px;
  background-color: var(--white);
  text-align: center;
}

.icon {
  display: block;
  max-width: 121px;
  height: auto;
  margin: 0 auto 22px;
}

.cardCopy {
  h1,
  h2,
  h3 {
    @include fluid-type(20px, 23px);
    line-height: math.div(27, 23);
    font-family: var(--roboto-condensed);
    margin-bottom: 7px;
  }

  p {
    font-size: to-rem(17px);
    line-height: math.div(27, 17);
    color: var(--gray-8);
    max-width: 235px;
    margin: auto;
  }
}

.ctaContainer {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
</style>
